import React from 'react'

import { DeviceType, useDeviceType } from '@library/dom'

import { CUSTOMER_REVIEWS } from '../../../config'
import { Carousel } from '../../EndlessVarietySection/Carousel'
import { ReviewsCard } from './ReviewsCard'
import { Box } from '@gousto-internal/citrus-react'
import { LandingPageContentSections } from '../../../tracking'

const propertiesForTracking = {
  carouselSection: LandingPageContentSections.CUSTOMER_REVIEWS,
}

export const ReviewsCarousel = () => {
  const deviceType = useDeviceType()
  const isMobileDevice = deviceType === DeviceType.MOBILE
  const carouselWrapperStyle = !isMobileDevice ? { paddingLeft: '8px' } : { paddingLeft: '0px' }
  const carouselAlign = isMobileDevice ? 'start' : 'center'
  const carouselLoop = isMobileDevice ? false : true

  return (
    <Box data-testid="reviews-carousel" style={carouselWrapperStyle}>
      <Carousel
        carouselAreaLabel="reviewsCarousel"
        options={{ align: carouselAlign, loop: carouselLoop }}
        slidePaddingH={2}
        slidePaddingV={1}
        showNavButtons={!isMobileDevice}
        autoHideNavButtons
        snowplowTrackingProperties={propertiesForTracking}
      >
        {CUSTOMER_REVIEWS.review.map(({ quote, reviewer }, index) => (
          <Box key={`${reviewer}-${index}`}>
            <ReviewsCard quote={quote} reviewer={reviewer} />
          </Box>
        ))}
      </Carousel>
    </Box>
  )
}
